import * as d3 from 'd3';
import { CategoricalChartData } from '../CategoricalChart/CategoricalChart.model';
import { NumberFormatHelper } from '../../..';

export class XAxis {
    private _scale: d3.scale.Linear<number, number>;
    private _axis: d3.svg.Axis;
    private _axisGroup: d3.Selection<any>;
    private _width: number;
    private _height: number;

    constructor(container: d3.Selection<SVGGElement>, width: number, height: number) {
        this.init(container, width, height);
        this.width(width)
            .height(height);
    }

    private init(container: d3.Selection<SVGGElement>, width: number, height: number) {
        const scale = d3.scale.linear()
            .domain([0, 1]);
        const axis = d3.svg.axis()
            .orient('bottom')
            .scale(scale)
            .ticks(6);
        const axisGroup = container.append('g')
            .classed('axis', true)
            .attr('transform', `translate(${0},${0})`);

        this._scale = scale;
        this._axis = axis;
        this._axisGroup = axisGroup;
    }

    height(): number;
    height(value: number): this;
    height(value?: number): this | number {
        if (!arguments.length) {
            return this._height;
        }
        this._height = value;
        return this;
    }

    width(): number;
    width(value: number): this;
    width(value?: number): this | number {
        if (!arguments.length) {
            return this._width;
        }
        this._width = value;
        this._scale
            .range([0, this._width]);
        return this;
    }

    extent(): number[];
    extent(value: number[]): this;
    extent(value?: number[]): this | number[] {
        if (!arguments.length) {
            return this._scale.domain();
        }
        this._scale.domain(value)
            .nice();
            const extent = value;
        const fmt = NumberFormatHelper.getFormat(extent[0], extent[1]);
        this._axis.tickFormat(fmt);
        return this;
    }

    position(value: number): number {
        let pos = this._scale(value);
        if (isNaN(pos)) {
            pos = 0;
        }
        return pos;
    }

    ticks(): number[] {
        const ticks = this._scale.ticks(6);
        return ticks;
    }

    tickFormat(value: string): this {
        if (value) {
            this._axis.tickFormat(d3.format(value));
        }
        return this;
    }

    render(data: CategoricalChartData[]): void {
        this._axisGroup
            // .transition()
            .attr('transform', `translate(${0},${this._height})`)
            .call(this._axis);
        const ticks = this._axisGroup.selectAll('.tick');
        ticks.select('text')
            .classed('tickLabel', true);
    }
}